import * as React from "react";

const CheckIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="#5f6368"
    viewBox="0 -960 960 960"
  >
    <path d="M382-253.85 168.62-467.23 211.38-510 382-339.38 748.62-706l42.76 42.77z"></path>
  </svg>
);

export default CheckIcon;
